let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bj9Pe")).then(() => parcelRequire('7icpf'));